/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Sync_Debt_HintInputs */

const vi_import_sync_debt_hint = /** @type {(inputs: Import_Sync_Debt_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khách mới tạo luôn được ghi công nợ từ file, không phụ thuộc lựa chọn này.`)
};

/**

* @param {Import_Sync_Debt_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const import_sync_debt_hint = /** @type {((inputs?: Import_Sync_Debt_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Sync_Debt_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_import_sync_debt_hint(inputs)
});